import { useState } from "react";
import "./App.css";
import Navbar from "./Components/Navbar/Navbar";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import HomePage from "./Pages/HomePage/HomePage";
import SliderApp from "./Components/Slider/Slider";
import TypingText from "./Pages/Typer/Typer";
import FeaturesPop from "./Pages/FeaturesPoP-up/FeaturesPop";
import IntegrationPoP from "./Pages/Integrations/IntegrationPoP";
import Login from "./Pages/Login/Login";
import Signup from "./Pages/Signup/Signup";
import Companyinfo from "./Pages/Companyinfo/Companyinfo";
import Pricing from "./Pages/Pricing/Pricing";
import Graphs from "./Pages/Graphs/Graphs";
import Scrolling from "./Components/Scrolling/Scrolling";
import Plan from "./Components/Plan/Plan";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./Pages/TermsAndConditions/TermsAndConditions";
import RefundPolicy from "./Pages/RefundPolicy/RefundPolicy";

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

function AppContent() {
  const location = useLocation(); // Get the current location (URL)

  return (
    <>
      {/* Conditionally render Navbar based on the current path */}
      {location.pathname !== "/Plan" && (
        <div className="navbar_app">
          <Navbar />
        </div>
      )}

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/Pricing" element={<Pricing />} />
        <Route path="/Signup" element={<Signup />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/Companyinfo" element={<Companyinfo />} />
        <Route path="/IntegrationPoP" element={<IntegrationPoP />} />
        <Route path="/FeaturesPop" element={<FeaturesPop />} />
        <Route path="/graphs" element={<Graphs />} />
        <Route path="/Plan" element={<Plan />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy/>}/>
        <Route path="/TermsAndConditions" element={<TermsAndConditions/>}/>
        <Route path="/RefundPolicy" element={<RefundPolicy/>}/>
      </Routes>
    </>
  );
}

export default App;
